<template>
  <div class="flex flex-col items-center pb-28">
    <div class="bgImage w-full relative">
      <img src="@/assets/images/booking-assurance.jpg" alt="Booking Assurance" class="absolute inset-0 w-full h-full object-cover z-0" />
    </div>
    <div class="container flex flex-col items-center self-stretch w-full max-md:px-5 max-md:max-w-full">
      <!-- Mobile Page Title -->
      <h1 class="self-start responsive-title-2 text-black max-md:max-w-full pt-24">
        {{ $t('bookingAssurance.header') }}
      </h1>

      <div class="mt-8 responsive-body-large text-black mix-blend-multiply max-md:max-w-full">
        {{ $t('bookingAssurance.body') }}
      </div>


      <!-- Steps Section -->
      <div class="w-full max-md:max-w-full">
        <!-- Step Rows -->
        <div v-for="(step, index) in steps" :key="index" class="flex gap-0 mt-14 max-md:flex-col md:gap-15 md:mt-20 ">
          <div class="flex flex-col w-6/12 max-md:ml-0 max-md:w-full">
            <div class="flex flex-col font-semibold max-md:mt-0 max-md:max-w-full">
              <img :src="step.src" :alt="step.alt" class="h-10 w-10" />
              <div class="mt-2.5 responsive-body-large text-black max-md:max-w-full">
                {{ step.title }}
              </div>
              <div class="mt-4 responsive-body-medium font-normal text-neutral-400 max-md:max-w-full">
                {{ step.description }}
              </div>
            </div>
          </div>
          <div class="flex flex-col md:ml-5 w-6/12 max-md:ml-0 max-md:w-full">
            <div class="flex flex-col font-semibold max-md:mt-10 max-md:max-w-full">
              <img :src="step.src2" :alt="step.alt2" class="h-10 w-10" />
              <div class="mt-2.5 responsive-body-large text-black max-md:max-w-full">
                {{ step.subTitle }}
              </div>
              <div class="mt-4 responsive-body-medium font-normal text-neutral-400 max-md:max-w-full">
                {{ step.subDescription }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script setup>
import { reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { getAsset } from "@/helpers/assetsUtils";

const { t } = useI18n();

const steps = reactive([
  {
    number: "1",
    src: getAsset('homeSvg', 'secure.svg'),
    alt: 'Secure',
    title: t('bookingAssurance.items[0].title'),
    description: t('bookingAssurance.items[0].description'),
    subNumber: "2",
    src2: getAsset('homeSvg', 'compass.svg'),
    alt2: 'Trusted',
    subTitle: t('bookingAssurance.items[0].subTitle'),
    subDescription: t('bookingAssurance.items[0].subDescription'),
  },
  {
    number: "3",
    src: getAsset('homeSvg', 'certified.svg'),
    alt: 'Certified',
    title: t('bookingAssurance.items[1].title'),
    description: t('bookingAssurance.items[1].description'),
    subNumber: "4",
    src2: getAsset('homeSvg', 'support.svg'),
    alt2: 'Support',
    subTitle: t('bookingAssurance.items[1].subTitle'),
    subDescription: t('bookingAssurance.items[1].subDescription'),
  },
]);

</script>

<style scoped>
.bgImage {
  background-size: cover;
  background-position: center;
  max-height: 650px;
  height: 65vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  gap: 40px;
}
</style>
